var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    {
      staticClass:
        "db footer-margin relative bg-footer layout-footer z-footer pv4 pv5-ns",
      class: { "il-footer-bg": _vm.isInsideLandsPage },
    },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "div",
          { staticClass: "db relative center mw8-5 footer-inner pv4" },
          [
            _c("div", { staticClass: "db dn-l" }, [
              _c(
                "h3",
                { staticClass: "f3 mv3 tl is-tablet-cond-bold is-white" },
                [_vm._v("\n          We’ll send you the latest\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "relative mb4 pb3" },
                [_c("signup-form")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex mt4 mb4 flex-row items-center justify-between mw20rem",
                },
                _vm._l(_vm.footer_content.socials, function (social) {
                  return _c(
                    "a",
                    {
                      key: social.title,
                      staticClass:
                        "dib relative pointer social-icon is-white-icon",
                      attrs: {
                        href: social.link,
                        target: "_blank",
                        title: social.title,
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "icon",
                        domProps: { innerHTML: _vm._s(social.icon_svg) },
                      }),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "relative mt2 mb4 tl" },
                _vm._l(_vm.footer_content.footer_navigation, function (item) {
                  return item.is_published
                    ? _c(
                        "div",
                        {
                          key: item.title,
                          staticClass:
                            "db relative w-100 mv3 footer-nav-parent-container",
                        },
                        [
                          _c(
                            "footer-nav-item",
                            [
                              _c(
                                "template",
                                { slot: "parent-nav-link" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "db is-white nav-link no-underline f4 is-tablet-cond-bold is-white",
                                      attrs: {
                                        to: item.link,
                                        title: item.title,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.title) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                { slot: "sub-nav-links" },
                                _vm._l(item.sub_nav_items, function (sub_item) {
                                  return sub_item.is_published
                                    ? _c(
                                        "router-link",
                                        {
                                          key: sub_item.title,
                                          staticClass:
                                            "db mv3 f4 is-white no-underline is-tablet-regular nav-link",
                                          attrs: {
                                            to: sub_item.link,
                                            title: sub_item.title,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(sub_item.title) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "db relative mt3 w-100 mw21rem tl f5" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-row items-center justify-between",
                    },
                    _vm._l(
                      _vm.footer_content.producer_partners,
                      function (item, index) {
                        return _c(
                          "a",
                          {
                            key: "producer-partner-" + index,
                            staticClass: "db relative mr4 partner-icon pointer",
                            class: item.css_class,
                            attrs: {
                              href: item.link,
                              target: "_blank",
                              title: item.title,
                            },
                          },
                          [
                            _c("simple-svg", {
                              staticClass: "icon",
                              attrs: {
                                filepath: item.image,
                                id: "partner-icon" + item.title,
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "db relative mt4 tl f5 is-white" },
                [
                  _vm._v("\n          © Outside Lands 2021 |\n          "),
                  _c(
                    "router-link",
                    {
                      staticClass: "u link is-white pointer",
                      attrs: {
                        to: "/privacy-policy/",
                        title: "Privacy Policy",
                      },
                    },
                    [_c("u", [_vm._v("Privacy Policy")])]
                  ),
                  _vm._v("\n          |\n          "),
                  _c(
                    "router-link",
                    {
                      staticClass: "u link is-white pointer",
                      attrs: {
                        to: "/terms-and-conditions/",
                        title: "Terms & Conditions",
                      },
                    },
                    [_c("u", [_vm._v("Terms & Conditions")])]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dn db-l relative" }, [
              _c("div", { staticClass: "row middle-sm pb4" }, [
                _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-row items-center justify-between tr",
                    },
                    _vm._l(_vm.footer_content.socials, function (social) {
                      return _c(
                        "a",
                        {
                          key: social.title,
                          staticClass:
                            "dib relative pointer social-icon is-white-icon",
                          attrs: {
                            href: social.link,
                            target: "_blank",
                            title: social.title,
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "icon",
                            domProps: { innerHTML: _vm._s(social.icon_svg) },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "relative row centering" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3  col-lg-4 relative re-size-form",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex relative flex-row items-center footer-sign-outer",
                          },
                          [
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "w6 f4 mv3 tc ttn is-bureau-bold is-white mr1 new-header",
                              },
                              [
                                _vm._v(
                                  "\n                We’ll send you the latest\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "relative w-100 mw-footer-signup ml2",
                              },
                              [_c("signup-form")],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col spacing-col" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-2 center margin-fix" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "db is-white ttn nav-link no-underline f4 is-tablet-bold",
                              attrs: { to: "/tickets/" },
                            },
                            [_vm._v("\n            Tickets\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "relative mv2" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "db mv3 is-white no-underline f6 is-tablet-regular nav-link",
                                  attrs: { to: "/premium-experiences/" },
                                },
                                [
                                  _vm._v(
                                    "\n              Premium Experiences\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-2 center margin-fix" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "db is-white ttn nav-link no-underline f4 is-tablet-bold",
                              attrs: { to: "/lineup/" },
                            },
                            [_vm._v("\n            Lineup\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "relative mv2" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "db mv3 is-white no-underline f6 is-tablet-regular nav-link",
                                  attrs: { to: "/past-lineups/" },
                                },
                                [
                                  _vm._v(
                                    "\n              Past Lineups\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col spacing-col" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-2 center margin-fix" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "db is-white ttn nav-link no-underline f4 is-tablet-bold",
                              attrs: { to: "/lineup/" },
                            },
                            [_vm._v("\n            News\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "relative mv2" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "db mv3 is-white no-underline f6 is-tablet-regular nav-link",
                                  attrs: { to: "/past-lineups/" },
                                },
                                [
                                  _vm._v(
                                    "\n              Most Recent\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-2 center" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "db is-white ttn nav-link no-underline f4 is-tablet-bold",
                              attrs: { to: "/contact/" },
                            },
                            [_vm._v("\n            Connect\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "relative mv2" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "db mv3 is-white no-underline f6 is-tablet-regular nav-link",
                                  attrs: { to: "/contact/" },
                                },
                                [
                                  _vm._v(
                                    "\n              Contact Us\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "db mv3 is-white no-underline f6 is-tablet-regular nav-link",
                                  attrs: { to: "/press/" },
                                },
                                [
                                  _vm._v(
                                    "\n              Press\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.footer_content.footer_navigation,
                      function (item) {
                        return _c(
                          "div",
                          {
                            key: item.title,
                            staticClass: "col-md-2 center",
                            class: { dn: !item.is_published },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "db is-white ttn nav-link no-underline f4 is-tablet-bold",
                                attrs: { to: item.link, title: item.title },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.title) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "relative mv2" },
                              _vm._l(item.sub_nav_items, function (sub_item) {
                                return sub_item.is_published
                                  ? _c(
                                      "router-link",
                                      {
                                        key: sub_item.title,
                                        staticClass:
                                          "db mv3 is-white no-underline f6 is-tablet-regular nav-link",
                                        attrs: {
                                          to: sub_item.link,
                                          title: sub_item.title,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(sub_item.title) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "relative w-100 pt4" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "db absolute left-0 abs-vert-center tl f5 is-white",
                  },
                  [
                    _vm._v(
                      "\n            © Outside Lands 2021 |\n            "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "u link is-white pointer",
                        attrs: {
                          to: "/privacy-policy/",
                          title: "Privacy Policy",
                        },
                      },
                      [_c("u", [_vm._v("Privacy Policy")])]
                    ),
                    _vm._v("\n            |\n            "),
                    _c(
                      "router-link",
                      {
                        staticClass: "u link is-white pointer",
                        attrs: {
                          to: "/terms-and-conditions/",
                          title: "Terms & Conditions",
                        },
                      },
                      [_c("u", [_vm._v("Terms & Conditions")])]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "db absolute right-0 abs-vert-center w8",
                    staticStyle: { width: "400px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex relative width-icons flex-row items-center justify-between",
                      },
                      _vm._l(
                        _vm.footer_content.producer_partners,
                        function (item) {
                          return _c(
                            "a",
                            {
                              key: item.title,
                              staticClass:
                                "dib relative center mv3 pl8 pointer partner-icon mw10rem",
                              class: item.css_class,
                              attrs: {
                                href: item.link,
                                target: "_blank",
                                title: item.title,
                              },
                            },
                            [
                              _c("simple-svg", {
                                staticClass: "icon",
                                attrs: {
                                  filepath: item.image,
                                  id: "partner-icon" + item.title,
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }